import { render, staticRenderFns } from "./ApprovalsPage.vue?vue&type=template&id=5f326142&scoped=true"
import script from "./ApprovalsPage.vue?vue&type=script&lang=ts"
export * from "./ApprovalsPage.vue?vue&type=script&lang=ts"
import style0 from "./ApprovalsPage.vue?vue&type=style&index=0&id=5f326142&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f326142",
  null
  
)

export default component.exports